import { render, staticRenderFns } from "./tipsDialog.vue?vue&type=template&id=1856bec8&scoped=true"
import script from "./tipsDialog.vue?vue&type=script&lang=js"
export * from "./tipsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1856bec8",
  null
  
)

export default component.exports